var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTableSimple',_vm._g(_vm._b({staticClass:"BTablePublicationMunMeh",attrs:{"headers":_vm.headers,"actions":_vm.actions}},'BTableSimple',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }